import script from "./HeaderDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderDefault.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderDefault.vue?vue&type=style&index=0&id=218fbb90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218fbb90"]])

export default __exports__